import theme from '../../../../../lib/theme';

const {
  layouts,
  scale,
  media,
  colors,
  font: { families, heights, spacings },
} = theme;

export default () => ({
  container: {
    padding: `0 !important`,
	},
  menuTileContainer: {
    display: 'flex',
    gap: '0',
    flexWrap: 'wrap',
    paddingTop: '0 !important',
  },
  menuTile: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    flex: '0 0 calc(100% / 3)',
    height: '325px',
    position: 'relative',
    zIndex: '0',

    '&.showLinks': {

      '.bgColour': {
        justifyContent: 'flex-stretch !important',
      },
      '.links': {
        bottom: '0 !important',
        zIndex: '0',
        flex: '1 1 auto !important',
        height: '200px',
        maxHeight: '200px',

        // [media.m.down]: {
        //   maxHeight: '200px',
        // },    
      }
    }
  },
  bgImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    zIndex: '0',
  },
  bgColour: {
    width: '100%',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    cursor: 'pointer',
    position: 'relative',
    padding: '1em',
  },
  menuTileContent: {
    padding: `${scale.xxxs}`,
    flex: '1 1 auto',

    [media.s.up]: {
      flex: '0 0 auto',
    },
  },
  menuTileTitle: {
    marginBottom: '0 !important',
    fontWeight: 700,
  },
  menuTileExcerpt: {
    fontSize: '1.5rem !important',
  },

	links: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    gap: scale.xxxs,
    height: '0',
    width: '100%',
    padding: '0',
    position: 'relative',
    bottom: '0',
    zIndex: -10,
    overflowY: 'scroll',
    transition: '1s',
  },
  menuItemLink: {
    padding: `${scale.xxxs} ${scale.xxs}`,
    background: 'rgba(255, 255, 255, 0.5)',
    fontSize: scale.xs,
    display: 'flex',
    justifyContent: 'space-between',
    gap: '5px',
    alignItems: 'center',

    '> a': {
      color: '#000000',
      textDecoration: 'none',

      ':hover, :active, :link :active': {
        textDecoration: 'none',
        color: colors.sas.primary,
      }
    }
  }
});